// extracted by mini-css-extract-plugin
module.exports = {"draggable_container":"BoxMatch_draggable_container__2LUlW","box_text_item":"BoxMatch_box_text_item__FDOW2","top_keyhole":"BoxMatch_top_keyhole__2fxHV"};